<div class="col matrix">
  <!-- Dropdowns -->
  <div *ngIf="keySections?.length > 0" [flex]="0" class="row center dropdowns padding all" [@fadeIn]>
    <div class="col full-width padding all">
      <div class="custom margin sm bottom">Key Section</div>
      <mat-select
        matNativeControl
        [(value)]="defaultKeySection"
        (selectionChange)="emitKeySection($event.value)"
        *ngIf="!selectedBook"
        [@fadeIn]
      >
        <mat-option *ngFor="let keySection of keySections" [value]="keySection">
          {{ keySection.name }}
        </mat-option>
      </mat-select>
      <div class="data margin lrg top right bottom left" *ngIf="selectedBook">
        <div *ngIf="selectedBookKeyway" [@fadeIn]>
          {{ selectedBookKeyway.name }}
        </div>
      </div>
    </div>
  </div>

  <!-- Master Key Combination -->
  <app-kba-input-array
    *ngIf="matrix?.masterKeyBitting && keySections?.length > 0"
    (inputsOut)="setInputs($event)"
    (inputUpdates)="update()"
    [block]="[matrix?.masterKeyBitting]"
    [disabled]="true"
  >
    Master Key Combination
  </app-kba-input-array>

  <!-- Key Bitting Array -->
  <app-kba-input-array
    *ngIf="matrix?.keyBitArray && keySections?.length > 0"
    (checkForEmptyKbaColumn)="checkIfKbaColumnEmpty()"
    (inputsOut)="setInputs($event)"
    (inputUpdates)="update()"
    [block]="matrix?.keyBitArray"
    [chamberId]="structure.chamberTypeId"
    [label]="'KBA'"
    [disabled]="selectedBook"
  >
    Key Bitting Array
  </app-kba-input-array>

  <!-- Sequence of Progression -->
  <app-kba-input-array
    *ngIf="matrix?.sequenceOfProgression && keySections?.length > 0"
    (inputsOut)="setInputs($event)"
    (inputUpdates)="update()"
    [chamberId]="structure.chamberTypeId"
    [label]="'SOP'"
    [block]="[matrix?.sequenceOfProgression]"
    [disabled]="selectedBook"
  >
    Sequence of Progression
  </app-kba-input-array>

  <!-- Mask -->
  <app-kba-input-array
    *ngIf="matrix?.mask && keySections?.length > 0"
    (checkForEmptyKbaColumn)="checkIfKbaColumnEmpty()"
    (inputsOut)="setInputs($event)"
    (inputUpdates)="update()"
    [block]="[matrix?.mask]"
    [chamberId]="structure.chamberTypeId"
    [label]="'Mask'"
    [disabled]="selectedBook"
  >
    Mask
  </app-kba-input-array>
</div>
